import { Controller } from '@hotwired/stimulus'

// Submits an activity_stream DELETE via fetch and removes the card on success.
// AON runs Turbo (no Rails-UJS), so `remote: true` on the form is a no-op.
export default class extends Controller {
  static targets = ['card']

  async destroy (event) {
    event.preventDefault()

    const form = event.currentTarget
    const csrfToken =
      document.querySelector('meta[name="csrf-token"]')?.content || ''

    const response = await fetch(form.action, {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'X-CSRF-Token': csrfToken
      },
      credentials: 'same-origin'
    })

    if (response.ok) {
      const card = this.hasCardTarget ? this.cardTarget : this.element
      card.remove()
    }
  }
}
